import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Layout, Row, message as antMessage, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useParams } from 'react-router-dom';
import LoginForm from './LoginForm';
import RegisterForm from './RegisterForm';
import ForgotPwdForm from './ForgotPwdForm';
import useHandleResize from '../../utils/HandleResize';
import ChangePwdForm from './ChangePwdForm';
import FirstLoginCustomerForm from './FirstLoginCustomerForm';
import Logo from '../../assets/images/logo-white-asx.png';
import BackgroundPhoto from '../../assets/images/ASSURMAX-background.jpg';
import UpdateAlert from '../../components/UpdateAlert/UpdateAlert';
import ModalContactLogin from './ModalContactLogin';

const Login = () => {
  const { token } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const firstPwd = params.get('firstPwd');
  const question = params.get('question');
  const { t } = useTranslation();
  const { width, height } = useHandleResize();
  const [currentForm, setCurrentForm] = useState('login');
  const [current, setCurrent] = useState(0);
  const [mail, setMail] = useState('');
  const [email, setEmail] = useState('');
  const [insurer, setInsurer] = useState();
  const [visible, setVisible] = useState(false);

  const openModal = () => {
    setVisible(true);
  };

  const handleModalClose = () => {
    setVisible(false);
  };

  const forms = {
    login: (
      <LoginForm
        switchForm={(f) => setCurrentForm(f)}
        currentForm={currentForm}
        setMail={setMail}
        mail={mail}
        setCurrent={setCurrent}
        current={current}
        setInsurer={setInsurer}
      />
    ),
    register: (
      <RegisterForm
        switchForm={(f) => setCurrentForm(f)}
        current={current}
        setCurrent={setCurrent}
        mail={mail}
        insurer={insurer}
        setInsurer={setInsurer}
        email={email}
        setEmail={setEmail}
        setMail={setMail}
      />
    ),
    forgotPwd: <ForgotPwdForm switchForm={(f) => setCurrentForm(f)} />,
    changePwd: (
      <ChangePwdForm switchForm={(f) => setCurrentForm(f)} token={token} />
    ),
    choosePwd: (
      <ChangePwdForm switchForm={(f) => setCurrentForm(f)} token={token} />
    ),
    firstLoginCustomer: (
      <FirstLoginCustomerForm switchForm={(f) => setCurrentForm(f)} />
    )
  };

  useEffect(() => {
    if (location && location.search === '?=callMeBack') {
      antMessage.success(t(`login.email_sent`));
    }
    if (token) {
      if (firstPwd) setCurrentForm('choosePwd');
      else setCurrentForm('changePwd');
    }
    // eslint-disable-next-line
  }, [token]);

  useEffect(() => {
    if (question === 'true') {
      (() => {
        openModal();
      })();
      // eslint-disable-next-line
    }
  }, [question]);

  const isReductScreen = width < 993;

  return (
    <div>
      <UpdateAlert />
      <Layout
        style={{
          minHeight: '100vh',
          maxHeight: '100vh',
          display: 'inherit',
          overflow: 'hidden'
        }}
      >
        <Row>
          <Col
            xs={{ span: 24 }}
            md={{ span: 24 }}
            lg={{ span: 24 }}
            style={{ backgroundColor: 'var(--componentBackground)' }}
          >
            <Row
              justify="center"
              align="middle"
              style={{
                height: '100vh',
                maxHeight: '100vh',
                backgroundImage: `url(${BackgroundPhoto})`,
                backgroundPosition: 'center',
                overflow: 'hidden',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover'
              }}
            >
              <Col
                xxl={7}
                xl={9}
                lg={12}
                sm={18}
                xs={24}
                style={{
                  height: '100vh',
                  maxHeight: '100vh',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: height < 1100 ? 'flex-start' : 'center',
                  textAlign: 'center',
                  padding: isReductScreen
                    ? '10px 0px 0px 0px'
                    : '20px 20px 0 20px',
                  overflowY: 'auto',
                  overflowX: 'hidden'
                }}
              >
                {width > 768 && (
                  <img
                    style={{
                      width: 300,
                      marginBottom: 90,
                      alignSelf: 'center'
                    }}
                    alt="Logo"
                    src={Logo}
                  />
                )}
                {width < 768 && height > 550 && (
                  <img
                    alt="logo"
                    style={{
                      width: '80%',
                      maxWidth: '300px',
                      marginBottom: 80,
                      alignSelf: 'center'
                    }}
                    src={Logo}
                  />
                )}
                {width < 768 && height <= 550 && (
                  <img
                    alt="logo"
                    style={{
                      width: '60%',
                      maxWidth: '300px',
                      marginBottom: 40,
                      alignSelf: 'center'
                    }}
                    src={Logo}
                  />
                )}
                {forms[currentForm]}
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
      <Modal
        title={t('login.modal_contact_login')}
        open={visible}
        onCancel={() => handleModalClose()}
        footer={null}
        width={isReductScreen ? 300 : 700}
        style={{ top: isReductScreen ? '30px' : '100px' }}
      >
        <ModalContactLogin handleModalClose={handleModalClose} />
      </Modal>
    </div>
  );
};

Login.propTypes = {
  location: PropTypes.shape({}).isRequired
};

export default Login;
